<template>
  <table class="table is-hoverable has-text-grey-dark is-size-6 is-vcentered">
    <thead>
      <tr>
        <th class="has-text-weight-bold">Item</th>
        <th>Amount</th>
        <th>Quantity</th>
        <th class="is-narrow has-text-right">Sub Total</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in invoice.items" :key="item.id">
        <td class="has-text-weight-bold">{{ item.item }}</td>
        <td>{{ item.amount | asCurrency }}</td>
        <td>{{ item.quantity }}</td>
        <td class="has-text-right">{{ item.subtotal | asCurrency }}</td>
      </tr>
      <tr class="is-selected">
        <td colspan="3" class="has-text-right has-text-weight-bold has-text-grey-darker">Total</td>
        <td class="is-narrow has-text-right has-text-weight-bold has-text-grey-darker">
          <span>{{ invoice.display_total }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {

  props: {
    invoice: Object
  }

}
</script>